import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { RiferimentiPosizioneDTO } from "../dto/riferimento-posizioneDTO";
import { MapperTipoIstanzaFascicolo } from "./mapper-tipo-istanza-fascicolo";
import { RiferimentiPosizioneVO } from "../vo/riferimenti-posizioneVO";
import { ElementoVicinoDTO } from "../dto/elemento-vicinoDTO";
import { ElementoVicinoVO } from "../vo/elemento-vicinoVO";
import { DettaglioErroreDTO } from "../dto/dettaglio-erroreDTO";
import { DettaglioErroreVO } from "../vo/dettaglio-erroreVO";
import { MapperMessaggioErrore } from "./mapper-messaggio-errore";

@Injectable({
  providedIn: "root",
})
export class MapperDettaglioErrore
  implements MapperInterface<DettaglioErroreDTO, DettaglioErroreVO> {
  constructor(private mapperMessaggioErrore: MapperMessaggioErrore) {}
  convertVoToDto(vo: DettaglioErroreVO): DettaglioErroreDTO {
    if (vo != null) {
      const dto = new DettaglioErroreDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.tipoElementoEnum = vo.tipoElementoEnum;
      dto.idElemento = vo.idElemento;
      dto.oggetto = vo.oggetto;
      dto.messaggioErrore = this.mapperMessaggioErrore.convertListVoToDto(
        vo.messaggioErrore
      );

      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: DettaglioErroreDTO): DettaglioErroreVO {
    if (dto != null) {
      const vo = new DettaglioErroreVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.idElemento = dto.idElemento;
      vo.oggetto = dto.oggetto;
      vo.tipoElementoEnum = dto.tipoElementoEnum;
      vo.messaggioErrore = this.mapperMessaggioErrore.convertListDtoToVo(
        dto.messaggioErrore
      );
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: DettaglioErroreVO[]): DettaglioErroreDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: DettaglioErroreDTO[]): DettaglioErroreVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
